import React from "react";
import {
  PRODUCT_CAROUSEL_ITEM_CLASSNAME,
  PRODUCT_CAROUSEL_TRACK_CLASSNAME,
} from "@/features/instantsearch/components";

/**
 * ProductCard Skeleton Loader
 *
 * ProductCard component'inin yükleme durumu için skeleton placeholder
 */
export const ProductCardSkeleton: React.FC = () => {
  return (
    <div className="@container/card flex h-full w-full flex-col border border-gray-200 dark:border-gray-700 rounded-xl @min-[200px]/card:rounded-2xl p-1.5 @min-[200px]/card:p-2 bg-white dark:bg-gray-800">
      {/* Image Skeleton */}
      <div className="relative aspect-square shrink-0 rounded-lg @min-[200px]/card:rounded-xl overflow-hidden mb-1.5 @min-[200px]/card:mb-3 bg-gray-100 dark:bg-gray-800">
        <div className="absolute inset-0 animate-pulse bg-gray-200 dark:bg-gray-700" />
      </div>

      {/* Content Skeleton — gerçek kartın satır yüksekliğiyle aynı */}
      <div className="flex flex-1 flex-col gap-1 @min-[200px]/card:gap-2 px-0.5 @min-[200px]/card:px-1">
        <div className="flex min-h-6 shrink-0 items-center justify-between gap-1 @min-[200px]/card:min-h-7">
          <div className="h-5 w-16 animate-pulse rounded-md bg-gray-200 dark:bg-gray-700 @min-[200px]/card:w-20" />
          <div className="h-5 w-12 animate-pulse rounded-md bg-gray-200 dark:bg-gray-700" />
        </div>
        <div className="min-h-[1.75rem] space-y-1 @min-[200px]/card:min-h-[2.5rem]">
          <div className="h-3 w-full animate-pulse rounded bg-gray-200 dark:bg-gray-700" />
          <div className="h-3 w-3/4 animate-pulse rounded bg-gray-200 dark:bg-gray-700" />
        </div>
        <div className="h-4 shrink-0 @min-[200px]/card:h-5">
          <div className="h-3 w-1/3 animate-pulse rounded bg-gray-200 dark:bg-gray-700" />
        </div>
        <div className="mt-auto flex min-h-5 items-center @min-[200px]/card:min-h-6">
          <div className="h-4 w-1/2 animate-pulse rounded bg-gray-200 dark:bg-gray-700" />
        </div>
      </div>
    </div>
  );
};

/**
 * ProductCard Carousel Skeleton
 * 
 * Carousel'ler için birden fazla skeleton gösterir
 */
interface ProductCarouselSkeletonProps {
  count?: number;
}

export const ProductCarouselSkeleton: React.FC<ProductCarouselSkeletonProps> = ({
  count = 5,
}) => {
  return (
    <div className={PRODUCT_CAROUSEL_TRACK_CLASSNAME}>
      {[...Array(count)].map((_, idx) => (
        <div key={idx} className={PRODUCT_CAROUSEL_ITEM_CLASSNAME}>
          <ProductCardSkeleton />
        </div>
      ))}
    </div>
  );
};

